<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-02-23 13:54:22
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-06-25 09:53:35
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/wemeet-poster/src/views/mini-h5/pages/user_home_page/components/MainPageBtn.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div :class="customClass" class="bg-white mt-10 br-10 p-10 border-box d-flex a-center j-sb">
    <div class="btnBorder aligncenter" @click="downLoadVcf">
      {{$t('lang.t148')}}
    </div>
    <div class="btnBorder aligncenter">

      <div style="width:100%;" v-if="userBaseInfo.isContact == 'MY_AGREE' || userBaseInfo.isContact ==  'USER_AGREE'" @click="deleteUser">{{$t('lang.t152')}}</div>
      <div style="width:100%;" v-if="userBaseInfo.isContact == 'NO' || userBaseInfo.isContact == 'USER_IGNORE'" @click="addUser">{{$t('lang.t149')}}</div>
      <div style="width:100%;" v-if="userBaseInfo.isContact == 'MY_PENDING_AGREE' || userBaseInfo.isContact == 'USER_PENDING_AGREE'">{{$t('lang.t151')}}</div>
      <div style="width:100%;" v-if="userBaseInfo.isContact == null" @click="addUser">{{$t('lang.t149')}}</div>

    </div>
    <div class="btnBg aligncenter" @click="im">
      {{$t('lang.t150')}}
    </div>

    <!-- <van-overlay :show="show">
      <div class="dialogContainer">
        <div class="close" @click.stop="show =false">
          <img src="@/assets/closeIcon.png" style="width:15px;height:15px" alt="">
        </div>
        <div class="name text-ellipsis-1">{{userBaseInfo.name}}</div>
        <div class="position text-center text-ellipsis-2">{{userBaseInfo.company || userBaseInfo.companyName}}</div>
        <img :src="qrCodeUrl" alt="" class="qrCode">
        <div><img src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeetStatic/image/WeMeetMiniLogo.png" class="logo" alt=""></div>
        <div class="btn" @click.stop="confirmDownLoad">{{leftBtnWord}}
        </div>
      </div>
    </van-overlay> -->

  </div>
</template>
<script>
import QRCode from 'qrcode'
import { generateVcfFile, getPosterImgToAi } from '@/api/common'
import { contactInitialRequest, contactDelContact, getUserVcf } from '@/api/interNational'
export default {
  name: 'MainPageBtn',
  props: {
    customClass: {
      type: String,
      default: 'mx-12',
    },
    userBaseInfo: {
      type: Object,
      default: {},
    },
  },
  components: {},
  data() {
    return {
      show: false,
      loading: false,
    }
  },
  methods: {
    im() {
      this.$isLogin().then((res) => {
        let userBasicInfo = JSON.parse(localStorage.getItem('userInfo'))
        let imUrl = process.env.VUE_APP_IM_BASE_URL + `/#/detail?uid=${userBasicInfo.imUid}&fUserId=${this.userBaseInfo.userBaseInfoVo.imUid}&userName=${this.userBaseInfo.userBaseInfoVo.name}&language=${this.$i18n.locale}`
        location.href = imUrl
      })
    },
    addUser() {
      this.$isLogin().then((res) => {
        try {
          let data = {
            requestSource: 'SHARE_PUBLISH',
            targetUid: this.userBaseInfo.userBaseInfoVo.weMeetUid,
            type: 'addContact',
            language: this.userBaseInfo.userBaseInfoVo.language,
          }
          contactInitialRequest({}, data).then((res) => {
            this.$emit('refresh')
            // this.$dialog
            //   .alert({
            //     title: `解除联系人关系`,
            //     message: `解除联系人关系后，对方无法查看您的个人信息。但不会同时取消关注。您需要再点击取消关注后，才不会看到TA的主页和动态更新。`,
            //     confirmButtonColor: '#00c4c9',
            //     confirmButtonText: `解除联系人`,
            //     cancelButtonText: '再考虑一下',
            //     showCancelButton: true,
            //   })
            //   .then(() => {
            //     // on close
            //     contactDelContact({}, this.userBaseInfo.userBaseInfoVo.weMeetUid).then((res) => {

            //     })
            //   })
          })
        } catch (err) {
          console.log(err)
        }
      })
    },
    deleteUser() {
      console.log('123123123')
      try {
        this.$dialog
          .alert({
            title: this.$t('lang.t160'),
            message: this.$t('lang.t161'),
            confirmButtonColor: '#00c4c9',
            confirmButtonText: this.$t('lang.t163'),
            cancelButtonText: this.$t('lang.t162'),
            showCancelButton: true,
          })
          .then(() => {
            // on close
            contactDelContact({}, this.userBaseInfo.userBaseInfoVo.weMeetUid).then((res) => {
              this.$emit('refresh')
            })
          })
      } catch (err) {
        console.log(err)
      }
    },
    downLoadQrcode() {
      this.show = true
      // this.initQRCode()
    },
    downLoadVcf() {
      getUserVcf({}, { language: this.userBaseInfo.userBaseInfoVo.language, uid: this.userBaseInfo.userBaseInfoVo.weMeetUid }).then((res) => {
        console.log(res)
        const downloadLink = document.createElement('a')
        downloadLink.download = 'contact.vcf' // 设置下载文件的名称

        downloadLink.href = res.data.vcfFileUrl
        downloadLink.click()
      })
    },
  },
  mounted() {},
}
</script>



<style lang="less" scoped>
.aligncenter {
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnBorder {
  width: 30%;
 height: 32px;
  border-radius: 32px;
  border: 1px solid #00c4c9;
  color: #00c4c9;
  padding: 0 5px;
  box-sizing: border-box;
  text-align: center;
}
.btnBg {
  width: 30%;
  min-height: 32px;
  border-radius: 32px;
  background: #00c4c9;
  color: #fff;
  padding: 3px 5px;
  box-sizing: border-box;
  text-align: center;
}
.dialogContainer {
  width: 300px;
  height: 400px;
  background: #ffffff;
  border-radius: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 24px;
  box-sizing: border-box;
  .close {
    width: 25px;
    height: 25px;
    background: #f5f5f5;
    position: absolute;
    top: 12px;
    right: 12px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .name {
    font-size: 19px;
    color: #262626;
    font-weight: bold;
    margin-top: 5px;
  }
  .position {
    color: #8c8c8c;
    font-size: 15px;
    margin-top: 5px;
  }
  .qrCode {
    width: 160px;
    height: 160px;
    margin-top: 10px;
  }
  .logo {
    width: 80px;
    height: 19px;
    margin-top: 5px;
  }
  .btn {
    width: 250px;
    height: 44px;
    border-radius: 6px;
    border: 1px solid #cccccc;
    text-align: center;
    line-height: 44px;
    color: #666;
    font-size: 15px;
    margin-top: 25px;
  }
}
</style>
